<template>
  <div class="top-lay">
   
    <div class="tag-group" >
      <span class="tag-group__title" style="margin-right: 8px;text-align: right;vertical-align: middle;float: left;font-size: 14px; color: #606266;line-height: 40px;padding: 0 12px 2px 20px;-webkit-box-sizing: border-box;box-sizing: border-box;">线路</span>
      <el-radio-group v-model="busLinesId" @change="btnClick($event,'busLinesId')" size="medium" style="float:left;">
        <el-radio-button 
          v-for="item in busLinesList"
          :key="item.id"
          :label="item.id">
          {{ item.lineName }}
        </el-radio-button>
      </el-radio-group>
      <el-col v-if="buttonList!=null&&buttonList.length>0" :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form :inline="true" @submit.native.prevent>
          
          <el-form-item label="班次" prop="shiftName" label-width="60px">
          <el-select style="width: 120px;" v-model="shiftName" filterable clearable placeholder="请选择班次">
              <el-option
                v-for="item in shiftNameList"
                :key="item"
                :value="item"
                :label="item"
              >
                <span style="float: left">{{ item }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="司机" prop="driverId" label-width="60px">
          <el-select style="width: 120px;" v-model="driverId" filterable clearable placeholder="请选择司机">
              <el-option
                v-for="item in driverList"
                :key="item.Id"
                :value="item.Id"
                :label="item.Name"
              >
                <span style="float: left">{{ item.Name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车辆" prop="vehicleId" label-width="60px">
          <el-select style="width: 130px;" v-model="vehicleId" filterable clearable placeholder="请选择车辆">
              <el-option
                v-for="item in vehicleList"
                :key="item.Id"
                :value="item.Id"
                :label="item.LicensePlateNumber"
              >
                <span style="float: left">{{ item.LicensePlateNumber }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="taskState" label-width="60px">
          <el-select style="width: 120px;" v-model="taskState" filterable placeholder="请选择状态">
              <el-option
                v-for="item in stateDictionaryList"
                :key="item.key"
                :value="item.value"
                :label="item.label"
              >
                <span style="float: left">{{ item.label }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 这个就是当前页面内，所有的btn列表 -->
          <el-form-item v-for="item in buttonList" v-bind:key="item.id">
            <!-- 这里触发点击事件 -->
            <el-button :type="item.Func&&(item.Func.toLowerCase().indexOf('handledel')!= -1 ||item.Func.toLowerCase().indexOf('stop')!= -1 )? 'danger':'primary'" v-if="!item.IsHide" @click="callFunc(item)">{{item.name}}</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      
    </div>
    
    
  </div>
  
</template>
<script>
import { getBusLinesListPage, getDriverListPage, getVehiclesListPage, getClassSubitem, getDictionaryItem } from "../../api/api";

export default {
  name: "RunCenterTaskToolbar",
  data() {
    return {
      busLinesList: [], //线路列表
      driverList: [], //驾驶员列表
      vehicleList: [], //车辆列表
      shiftNameList: [], //班次列表
      stateDictionaryList: [], //状态字典列表
      busLinesId:"", //线路ID
      driverId:"", //驾驶员Id
      vehicleId:"", //驾驶员Id
      shiftName:"", //班次名称
      taskState:"" //状态
    };
  },
  props: ["buttonList"], //接受父组件传值
  methods: {
    callFunc(item) {
      let itemExt = {};
      if(item !== null){
        itemExt = item;
      }
      itemExt.busLinesId = this.busLinesId;
      itemExt.shiftName = this.shiftName;
      itemExt.driverId = this.driverId;
      itemExt.vehicleId = this.vehicleId;
      itemExt.taskState = this.taskState;     
      this.$emit("callFunction", itemExt); //将值传给父组件
    },   
    getBusLinesList(pageSizePara){
      getBusLinesListPage(pageSizePara).then(res => {
        this.busLinesList = [];
        this.busLinesId = '';
        if(res.data.response.dataCount > 0){
          for (let i = 0; i < res.data.response.dataCount; i++) {
            let busLinesDataObj = {};
            busLinesDataObj.id = res.data.response.data[i].Id;
            busLinesDataObj.type = i===0?'primary':'';
            busLinesDataObj.lineName = res.data.response.data[i].LineChineseName;
            this.busLinesList.push(busLinesDataObj);
            if(i===0){
              this.busLinesId = busLinesDataObj.id;
            }
          }
        }
      });
    },
    btnClick(value,type){
      if(type === "departureDate"){
        this.departureDate = value;
      } else if(type === "departureDatePicker"){
        this.departureDate = formatDate(value);
      } else{
        this.busLinesId = value;
      }
      this.callFunc(null);
    },
    getShiftNameList(){
      let para = {
      };
      getClassSubitem(para).then(res => {
        this.shiftNameList = res.data;
      });
    },
    getDriverList(){
      let para = {
        companyId: "",
        driverName: "",
        employmentStatus: "",
        page: 1,
        pageSize: 200
      };
      getDriverListPage(para).then(res => {
        this.driverList = res.data.response.data;
      });
    },
    getVehiclesList(){
      let para = {
        companyId: '',
        busLinesId: '',
        licensePlateNumber: '',
        terminalsId: '',
        simId: '',
        page: 1,
        pageSize: 200
      };
      getVehiclesListPage(para).then(res => {
        this.vehicleList = res.data.response.data;
      });
    },
    getStateDictionaryList(){
      let _this = this;
      let para = {
        dictName: '任务状态',
        dictCode: 'TaskStatus'
      };
      getDictionaryItem(para).then(res => {
        _this.stateDictionaryList = [];
        _this.stateDictionaryList.push({ key: -1, value: "", label: "全部" });
        if(res.data.length > 0){
          res.data.forEach(element => {
            _this.stateDictionaryList.push({ key: element.Id, value: element.DictCode, label: element.DictName });
          });
        }
      });
    }
  },
  mounted() {
    let pageSizePara = {
      pageSize: 100
    };
    this.getBusLinesList(pageSizePara);
    this.getShiftNameList();
    this.getDriverList();
    this.getVehiclesList();
    this.getStateDictionaryList();
  }
};
</script>
<style scoped>
  .top-lay{margin-left:5px;margin-bottom:35px; margin-top:0px; }
 
  </style>